import { render, staticRenderFns } from "./BrandsIndex.vue?vue&type=template&id=4126e466"
import script from "./BrandsIndex.vue?vue&type=script&lang=js"
export * from "./BrandsIndex.vue?vue&type=script&lang=js"
import style0 from "./BrandsIndex.vue?vue&type=style&index=0&id=4126e466&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports